<template>
  <div class="px-7" ref="subMenuRestrictionsRef">
    <v-btn-toggle v-model="optionSelected" multiple style="border: 1px solid #95a1ec" background-color="#212a35"
      :class="width > 300 ? 'btn-toggle-mb' : 'd-flex flex-column'">
      <v-btn v-for="(layer, index) in layers" :key="index" color="#95A1EC" height="28" class="btn-group" :value="layer">
        {{ layer.name }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'SubMenuLayerPesticides',
  props: ['layer', 'group'],
  data: () => ({
    optionSelected: [],
    width: 0,
    observer: null,
    layers: [
    {
        name: 'Área de Preservação Ambiental',
        value: 'areaPreservacaoAmbiental',
        layerId: 406,
        visible: false,
      },
      {
        name: 'Conservação de Biodiversidade',
        value: 'biodiversidade',
        layerId: 401,
        visible: false,
      },
      {
        name: 'Assentamentos',
        value: 'assentamentos',
        layerId: 402,
        visible: false,
      },
      {
        name: 'Reservas Particulares do Patrimônio Natural',
        value: 'rppn',
        layerId: 407,
        visible: false,
      },
      {
        name: 'Topografia',
        value: 'topografia',
        layerId: 403,
        visible: false,
      },
      {
        name: 'Terras Indígenas',
        value: 'terrasIndígenas',
        layerId: 404,
        visible: false,
      },
      {
        name: 'Sítios Arqueológicos (IPHAN)',
        value: 'sitiosArqueologicos',
        layerId: 408,
        visible: false,
      },
      {
        name: 'Unidades de Conservação',
        value: 'unidadesDeConservação',
        layerId: 405,
        visible: false,
      },
    ]

  }),
  mounted() {
    this.observer = new ResizeObserver(this.handleResize);
    this.observer.observe(this.$refs.subMenuRestrictionsRef);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  watch: {
    optionSelected() {
      this.changeLayersOfRestrictions();
    },
  },
  methods: {
    handleResize(entries) {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.width = width;
      }
    },

    changeLayersOfRestrictions() {
      this.layers.forEach(el => {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: { visible: false, layerId: el.layerId },
        });
        this.optionSelected.forEach(layer => {
          if (el.value == layer.value) {
            this.$emit('changeInputMenu', {
              eventName: 'changeEnabledSublayer',
              params: { visible: true, layerId: el.layerId },
            });
          }
        });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12.0833px;
  line-height: 15px;
  text-transform: none;
  color: #95a1ec;
  border: 1px solid #95a1ec;
}

::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle>.v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}

.btn-toggle-mb {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 2fr));
}
</style>
